import { render, staticRenderFns } from "./no-breadcrumb.vue?vue&type=template&id=3272a365&scoped=true&"
import script from "./no-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./no-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./no-breadcrumb.vue?vue&type=style&index=0&id=3272a365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272a365",
  null
  
)

export default component.exports